import type { HelpFile } from '../../types/help'
import { ProvisioningHistoryTestIds } from '../../../testids/ProvisioningHistoryTestIds'

export const provisioningHistoryHelp: HelpFile = {
  docPage: '/docs/provisioning/provisioning-history',
  texts: {
    [ProvisioningHistoryTestIds.provisioningHistoryPage]: 'Chronologische Aufzeichnung abgeschlossener, fehlgeschlagener und übersprungener Provisionierungs-Aufgaben.',
    [ProvisioningHistoryTestIds.btnRefresh]: null,
    [ProvisioningHistoryTestIds.colAction]: 'Bereitstellungsaktion — Gewähren, Entziehen oder Aktualisieren.',
    [ProvisioningHistoryTestIds.colCompletedAt]: 'Zeitpunkt, zu dem die Provisionierungs-Aufgabe abgeschlossen wurde — unabhängig vom Ergebnis.',
    [ProvisioningHistoryTestIds.colCreatedAt]: null,
    [ProvisioningHistoryTestIds.colEntitlement]: 'Enforcement-Objekt, das durch diese Aufgabe bereitgestellt, entzogen oder aktualisiert wurde.',
    [ProvisioningHistoryTestIds.colIdentity]: null,
    [ProvisioningHistoryTestIds.colRetries]: 'Anzahl der Wiederholungen nach vorübergehenden Fehlern.',
    [ProvisioningHistoryTestIds.colStatus]: null,
    [ProvisioningHistoryTestIds.colTargetSystem]: null,
    [ProvisioningHistoryTestIds.historyMinQHint]: null,
    [ProvisioningHistoryTestIds.historySearchScopeHint]: null,
  },
}
